import React from 'react';

const PrivatePolicy = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M15.5717 12H7.85742V13.2857H15.5717V12Z' fill='black' />
      <path
        d='M15.5717 8.14279H7.85742V9.42851H15.5717V8.14279Z'
        fill='black'
      />
      <path
        d='M11.7143 21L7.74413 18.8831C6.61222 18.281 5.66565 17.382 5.00602 16.2826C4.34639 15.1832 3.99861 13.925 4 12.6429V4.28571C4.00038 3.94484 4.13596 3.61803 4.37699 3.37699C4.61803 3.13595 4.94484 3.00037 5.28572 3H18.1429C18.4837 3.00037 18.8105 3.13595 19.0516 3.37699C19.2926 3.61803 19.4282 3.94484 19.4286 4.28571V12.6429C19.4299 13.9249 19.0822 15.1832 18.4225 16.2825C17.7629 17.3819 16.8163 18.2809 15.6844 18.883L11.7143 21ZM5.28572 4.28571V12.6429C5.28461 13.6919 5.56919 14.7214 6.10893 15.6209C6.64866 16.5204 7.42317 17.256 8.34932 17.7486L11.7143 19.5428L15.0793 17.7486C16.0054 17.256 16.7799 16.5204 17.3197 15.6209C17.8594 14.7214 18.144 13.6919 18.1429 12.6429V4.28571H5.28572Z'
        fill='black'
      />
    </svg>
  );
};

export default PrivatePolicy;
